// import React from 'react';
// import Icon from '../../../components/AppIcon';

// const ConcernAnalysis = ({ concerns }) => {
//   const getSentimentColor = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return 'text-success';
//       case 'negative':
//         return 'text-error';
//       case 'neutral':
//         return 'text-muted-foreground';
//       default:
//         return 'text-foreground';
//     }
//   };

//   const getSentimentIcon = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return 'ThumbsUp';
//       case 'negative':
//         return 'ThumbsDown';
//       case 'neutral':
//         return 'Minus';
//       default:
//         return 'MessageCircle';
//     }
//   };

//   const getTrendIcon = (trend) => {
//     if (trend > 0) return 'TrendingUp';
//     if (trend < 0) return 'TrendingDown';
//     return 'Minus';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       <div className="flex items-center justify-between mb-6">
//         <div>
//           <h3 className="text-lg font-semibold text-foreground mb-1">
//             Top Customer Concerns
//           </h3>
//           <p className="text-sm text-muted-foreground">
//             Most frequent issues with sentiment analysis
//           </p>
//         </div>
//         <Icon name="MessageSquare" size={24} color="var(--color-primary)" />
//       </div>
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => (
//           <div
//             key={concern?.id}
//             className="bg-background border border-border rounded-lg p-4 transition-base hover-lift hover:shadow-md"
//           >
//             <div className="flex items-start justify-between mb-3">
//               <div className="flex-1">
//                 <h4 className="text-sm font-semibold text-foreground mb-1">
//                   {concern?.category}
//                 </h4>
//                 <p className="text-xs text-muted-foreground line-clamp-2">
//                   {concern?.description}
//                 </p>
//               </div>
//               <div className={`flex-shrink-0 ml-2 ${getSentimentColor(concern?.sentiment)}`}>
//                 <Icon name={getSentimentIcon(concern?.sentiment)} size={18} />
//               </div>
//             </div>

//             <div className="space-y-2 mb-3">
//               <div className="flex items-center justify-between text-xs">
//                 <span className="text-muted-foreground">Volume</span>
//                 <span className="font-medium text-foreground">
//                   {concern?.volume?.toLocaleString()} calls
//                 </span>
//               </div>
              
//               <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
//                 <div
//                   className="h-full bg-primary rounded-full transition-all duration-500"
//                   style={{ width: `${concern?.percentage}%` }}
//                 />
//               </div>

//               <div className="flex items-center justify-between text-xs">
//                 <span className="text-muted-foreground">Resolution Rate</span>
//                 <span className="font-medium text-foreground">
//                   {concern?.resolutionRate}%
//                 </span>
//               </div>
//             </div>

//             <div className="flex items-center justify-between pt-3 border-t border-border">
//               <div className="flex items-center gap-1">
//                 <Icon 
//                   name={getTrendIcon(concern?.trend)} 
//                   size={14}
//                   className={getTrendColor(concern?.trend)}
//                 />
//                 <span className={`text-xs font-medium ${getTrendColor(concern?.trend)}`}>
//                   {concern?.trend > 0 ? '+' : ''}{concern?.trend}%
//                 </span>
//               </div>
//               <span className="text-xs text-muted-foreground">
//                 vs last week
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;

// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {

// const [dateFilter, setDateFilter] = useState('Last 7 Days');
// const [showCustomRange, setShowCustomRange] = useState(false);
// const [customStartDate, setCustomStartDate] = useState('');
// const [customEndDate, setCustomEndDate] = useState('');

// const handleDateChange = (value) => {
//   setDateFilter(value);
//   setShowCustomRange(value === 'Custom Range');
// };


//   const dateOptions = [
//     'Today',
//     'Yesterday',
//     'Last 7 Days',
//     'Last 14 Days',
//     'Last Month'
//   ];

//   const handleDownload = () => {
//     console.log('Downloading concern analysis for:', dateFilter);
//   };

//   const getSentimentColor = (sentiment) => {
//     if (sentiment === 'positive') return 'text-success';
//     if (sentiment === 'negative') return 'text-error';
//     return 'text-muted-foreground';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
// <SectionHeader
//   title="Top Customer Concerns"
//   subtitle="Most frequent issues with sentiment analysis"
//   dateFilter={dateFilter}
//   onDateChange={handleDateChange}
//   onDownload={handleDownload}
//   dateOptions={[
//     'Today',
//     'Yesterday',
//     'Last 7 Days',
//     'Last 14 Days',
//     'Last Month',
//     'Custom Range'
//   ]}
// />

// {/* ✅ SAME AS TREEMAP — FULL WIDTH */}
// {showCustomRange && (
//   <div className="bg-background border border-border rounded-lg p-4 mt-4 mb-6 animate-in fade-in slide-in-from-top-2 duration-200">
//     <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//       <div className="flex-1">
//         <label className="block text-xs font-medium text-muted-foreground mb-1">
//           Start Date
//         </label>
//         <input
//           type="date"
//           value={customStartDate}
//           onChange={(e) => setCustomStartDate(e.target.value)}
//           className="w-full bg-card border border-border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary/20"
//         />
//       </div>

//       <div className="flex-1">
//         <label className="block text-xs font-medium text-muted-foreground mb-1">
//           End Date
//         </label>
//         <input
//           type="date"
//           value={customEndDate}
//           onChange={(e) => setCustomEndDate(e.target.value)}
//           className="w-full bg-card border border-border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary/20"
//         />
//       </div>

//       <button
//         onClick={() =>
//           console.log('Apply range', customStartDate, customEndDate)
//         }
//         className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium mt-5 hover:bg-primary/90"
//       >
//         Apply
//       </button>
//     </div>
//   </div>
// )}


//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => (
//           <div
//             key={concern.id}
//             className="bg-background border border-border rounded-lg p-4 hover:shadow-md transition"
//           >
//             <div className="flex justify-between mb-3">
//               <div>
//                 <h4 className="text-sm font-semibold">
//                   {concern.category}
//                 </h4>
//                 <p className="text-xs text-muted-foreground">
//                   {concern.description}
//                 </p>
//               </div>
//               <Icon
//                 name="MessageCircle"
//                 size={18}
//                 className={getSentimentColor(concern.sentiment)}
//               />
//             </div>

//             <div className="text-xs flex justify-between mb-2">
//               <span className="text-muted-foreground">Volume</span>
//               <span className="font-medium">
//                 {concern.volume.toLocaleString()}
//               </span>
//             </div>

//             <div className="w-full bg-muted rounded-full h-2 mb-3">
//               <div
//                 className="h-full bg-primary rounded-full"
//                 style={{ width: `${concern.percentage}%` }}
//               />
//             </div>

//             <div className="flex justify-between text-xs border-t pt-3">
//               <span className={getTrendColor(concern.trend)}>
//                 {concern.trend > 0 ? '+' : ''}{concern.trend}%
//               </span>
//               <span className="text-muted-foreground">
//                 vs last period
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;

// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleDownload = () => {
//     console.log('Downloading concern analysis for:', {
//       dateFilter,
//       customStartDate,
//       customEndDate
//     });
//   };

//   /* ---------------- SENTIMENT ICONS ---------------- */

//   const getSentimentIcon = (sentiment) => {
//     if (sentiment === 'positive')
//       return { name: 'ThumbsUp', className: 'text-success' };

//     if (sentiment === 'negative')
//       return { name: 'ThumbsDown', className: 'text-error' };

//     return { name: 'ThumbsUp', className: 'text-muted-foreground opacity-50' };
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       <SectionHeader
//         title="Top Customer Concerns"
//         subtitle="Most frequent issues with sentiment analysis"
//         dateFilter={dateFilter}
//         onDateChange={handleDateChange}
//         onDownload={handleDownload}
//         dateOptions={[
//           'Today',
//           'Yesterday',
//           'Last 7 Days',
//           'Last 14 Days',
//           'Last Month',
//           'Custom Range'
//         ]}
//       />

//       {/* ✅ CUSTOM DATE RANGE (Same as Treemap) */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mt-4 mb-6 animate-in fade-in slide-in-from-top-2 duration-200">
//           <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//             <div className="flex-1">
//               <label className="block text-xs font-medium text-muted-foreground mb-1">
//                 Start Date
//               </label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full bg-card border border-border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary/20"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="block text-xs font-medium text-muted-foreground mb-1">
//                 End Date
//               </label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full bg-card border border-border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary/20"
//               />
//             </div>

//             <button
//               onClick={() =>
//                 console.log('Apply range', customStartDate, customEndDate)
//               }
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium mt-5 hover:bg-primary/90"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ---------------- CONCERNS GRID ---------------- */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const sentimentIcon = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="bg-background border border-border rounded-lg p-4 hover:shadow-md transition"
//             >
//               <div className="flex justify-between mb-3">
//                 <div>
//                   <h4 className="text-sm font-semibold">
//                     {concern.category}
//                   </h4>
//                   <p className="text-xs text-muted-foreground">
//                     {concern.description}
//                   </p>
//                 </div>

//                 {/* 👍👎 THUMB ICON ONLY */}
//                 <Icon
//                   name={sentimentIcon.name}
//                   size={18}
//                   className={sentimentIcon.className}
//                 />
//               </div>

//               <div className="text-xs flex justify-between mb-2">
//                 <span className="text-muted-foreground">Volume</span>
//                 <span className="font-medium">
//                   {concern.volume.toLocaleString()}
//                 </span>
//               </div>

//               <div className="w-full bg-muted rounded-full h-2 mb-3">
//                 <div
//                   className="h-full bg-primary rounded-full transition-all"
//                   style={{ width: `${concern.percentage}%` }}
//                 />
//               </div>

//               <div className="flex justify-between text-xs border-t pt-3">
//                 <span className={getTrendColor(concern.trend)}>
//                   {concern.trend > 0 ? '+' : ''}
//                   {concern.trend}%
//                 </span>
//                 <span className="text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;

// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');
//   const [appliedRange, setAppliedRange] = useState(null);

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleApplyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;

//     setAppliedRange({
//       startDate: customStartDate,
//       endDate: customEndDate
//     });

//     setDateFilter('Custom Range');
//     setShowCustomRange(false);

//     // 🔥 THIS is where API should be called
//     console.log('Applied custom range:', {
//       startDate: customStartDate,
//       endDate: customEndDate
//     });
//   };

//   const getSentimentIcon = (sentiment) => {
//     if (sentiment === 'positive')
//       return { name: 'ThumbsUp', className: 'text-success' };
//     if (sentiment === 'negative')
//       return { name: 'ThumbsDown', className: 'text-error' };
//     return { name: 'ThumbsUp', className: 'text-muted-foreground opacity-50' };
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       <SectionHeader
//         title="Top Customer Concerns"
//         subtitle="Most frequent issues with sentiment analysis"
//         dateFilter={dateFilter}
//         onDateChange={handleDateChange}
//         dateOptions={[
//           'Today',
//           'Yesterday',
//           'Last 7 Days',
//           'Last 14 Days',
//           'Last Month',
//           'Custom Range'
//         ]}
//       />

//       {/* ✅ CUSTOM RANGE */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mt-4 mb-6">
//           <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground">Start Date</label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground">End Date</label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <button
//               onClick={handleApplyCustomRange}
//               disabled={!customStartDate || !customEndDate}
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm mt-5 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* GRID */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const icon = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="bg-background border rounded-lg p-4"
//             >
//               <div className="flex justify-between mb-3">
//                 <div>
//                   <h4 className="text-sm font-semibold">
//                     {concern.category}
//                   </h4>
//                   <p className="text-xs text-muted-foreground">
//                     {concern.description}
//                   </p>
//                 </div>
//                 <Icon name={icon.name} size={18} className={icon.className} />
//               </div>

//               <div className="text-xs flex justify-between mb-2">
//                 <span className="text-muted-foreground">Volume</span>
//                 <span className="font-medium">
//                   {concern.volume.toLocaleString()}
//                 </span>
//               </div>

//               <div className="w-full bg-muted rounded-full h-2 mb-3">
//                 <div
//                   className="h-full bg-primary rounded-full"
//                   style={{ width: `${concern.percentage}%` }}
//                 />
//               </div>

//               <div className="flex justify-between text-xs border-t pt-3">
//                 <span className={getTrendColor(concern.trend)}>
//                   {concern.trend > 0 ? '+' : ''}
//                   {concern.trend}%
//                 </span>
//                 <span className="text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;

// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleApplyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;
//     setShowCustomRange(false);

//     console.log('Applied range:', customStartDate, customEndDate);
//   };

//   const getSentimentIcon = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return { name: 'ThumbsUp', className: 'text-success' };
//       case 'negative':
//         return { name: 'ThumbsDown', className: 'text-error' };
//       default:
//         return { name: 'Minus', className: 'text-muted-foreground' };
//     }
//   };

//   const getTrendIcon = (trend) => {
//     if (trend > 0) return 'TrendingUp';
//     if (trend < 0) return 'TrendingDown';
//     return 'Minus';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       {/* 🔹 Header */}
//       <div className="flex items-start justify-between mb-6">
//         <SectionHeader
//           title="Top Customer Concerns"
//           subtitle="Most frequent issues with sentiment analysis"
//           dateFilter={dateFilter}
//           onDateChange={handleDateChange}
//           dateOptions={[
//             'Today',
//             'Yesterday',
//             'Last 7 Days',
//             'Last 14 Days',
//             'Last Month',
//             'Custom Range'
//           ]}
//         />
//         <Icon name="MessageSquare" size={22} className="text-primary mt-1" />
//       </div>

//       {/* 🔹 Custom Date Range */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mb-6 animate-in fade-in slide-in-from-top-2">
//           <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground">Start Date</label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground">End Date</label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <button
//               onClick={handleApplyCustomRange}
//               disabled={!customStartDate || !customEndDate}
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm mt-5 hover:bg-primary/90 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* 🔹 Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const sentiment = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="bg-background border border-border rounded-lg p-4 transition hover:shadow-md"
//             >
//               {/* Title + Sentiment */}
//               <div className="flex items-start justify-between mb-3">
//                 <div className="flex-1">
//                   <h4 className="text-sm font-semibold text-foreground mb-1">
//                     {concern.category}
//                   </h4>
//                   <p className="text-xs text-muted-foreground line-clamp-2">
//                     {concern.description}
//                   </p>
//                 </div>
//                 <Icon
//                   name={sentiment.name}
//                   size={18}
//                   className={`ml-2 ${sentiment.className}`}
//                 />
//               </div>

//               {/* Volume + Progress */}
//               <div className="space-y-2 mb-3">
//                 <div className="flex justify-between text-xs">
//                   <span className="text-muted-foreground">Volume</span>
//                   <span className="font-medium">
//                     {concern.volume.toLocaleString()}
//                   </span>
//                 </div>

//                 <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
//                   <div
//                     className="h-full bg-primary rounded-full transition-all duration-500"
//                     style={{ width: `${concern.percentage}%` }}
//                   />
//                 </div>
//               </div>

//               {/* Trend */}
//               <div className="flex items-center justify-between pt-3 border-t border-border">
//                 <div className="flex items-center gap-1">
//                   <Icon
//                     name={getTrendIcon(concern.trend)}
//                     size={14}
//                     className={getTrendColor(concern.trend)}
//                   />
//                   <span
//                     className={`text-xs font-medium ${getTrendColor(
//                       concern.trend
//                     )}`}
//                   >
//                     {concern.trend > 0 ? '+' : ''}
//                     {concern.trend}%
//                   </span>
//                 </div>
//                 <span className="text-xs text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;


// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleApplyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;
//     setShowCustomRange(false);

//     console.log('Applied range:', customStartDate, customEndDate);
//   };

//   const getSentimentIcon = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return { name: 'ThumbsUp', className: 'text-success' };
//       case 'negative':
//         return { name: 'ThumbsDown', className: 'text-error' };
//       default:
//         return { name: 'Minus', className: 'text-muted-foreground' };
//     }
//   };

//   const getTrendIcon = (trend) => {
//     if (trend > 0) return 'TrendingUp';
//     if (trend < 0) return 'TrendingDown';
//     return 'Minus';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       {/* 🔹 Header (unchanged layout) */}
//       <div className="mb-6">
//         <SectionHeader
//           title="Top Customer Concerns"
//           subtitle="Most frequent issues with sentiment analysis"
//           dateFilter={dateFilter}
//           onDateChange={handleDateChange}
//           dateOptions={[
//             'Today',
//             'Yesterday',
//             'Last 7 Days',
//             'Last 14 Days',
//             'Last Month',
//             'Custom Range'
//           ]}
//         />
//       </div>

//       {/* 🔹 Custom Date Range (same Treemap behavior) */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mb-6 animate-in fade-in slide-in-from-top-2">
//           <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 Start Date
//               </label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 End Date
//               </label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <button
//               onClick={handleApplyCustomRange}
//               disabled={!customStartDate || !customEndDate}
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm mt-5 hover:bg-primary/90 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* 🔹 Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const sentiment = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="bg-background border border-border rounded-lg p-4 transition hover:shadow-md"
//             >
//               {/* Title + Sentiment */}
//               <div className="flex items-start justify-between mb-3">
//                 <div className="flex-1">
//                   <h4 className="text-sm font-semibold text-foreground mb-1">
//                     {concern.category}
//                   </h4>
//                   <p className="text-xs text-muted-foreground line-clamp-2">
//                     {concern.description}
//                   </p>
//                 </div>
//                 <Icon
//                   name={sentiment.name}
//                   size={18}
//                   className={`ml-2 ${sentiment.className}`}
//                 />
//               </div>

//               {/* Volume */}
//               <div className="space-y-2 mb-3">
//                 <div className="flex justify-between text-xs">
//                   <span className="text-muted-foreground">Volume</span>
//                   <span className="font-medium">
//                     {concern.volume.toLocaleString()}
//                   </span>
//                 </div>

//                 <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
//                   <div
//                     className="h-full bg-primary rounded-full transition-all duration-500"
//                     style={{ width: `${concern.percentage}%` }}
//                   />
//                 </div>
//               </div>

//               {/* Trend */}
//               <div className="flex items-center justify-between pt-3 border-t border-border">
//                 <div className="flex items-center gap-1">
//                   <Icon
//                     name={getTrendIcon(concern.trend)}
//                     size={14}
//                     className={getTrendColor(concern.trend)}
//                   />
//                   <span
//                     className={`text-xs font-medium ${getTrendColor(
//                       concern.trend
//                     )}`}
//                   >
//                     {concern.trend > 0 ? '+' : ''}
//                     {concern.trend}%
//                   </span>
//                 </div>
//                 <span className="text-xs text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;


// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleApplyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;
//     setShowCustomRange(false);

//     console.log('Applied range:', customStartDate, customEndDate);
//   };

//   const getSentimentIcon = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return { name: 'ThumbsUp', className: 'text-success' };
//       case 'negative':
//         return { name: 'ThumbsDown', className: 'text-error' };
//       default:
//         return { name: 'Minus', className: 'text-muted-foreground' };
//     }
//   };

//   const getTrendIcon = (trend) => {
//     if (trend > 0) return 'TrendingUp';
//     if (trend < 0) return 'TrendingDown';
//     return 'Minus';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       {/* Header */}
//       <div className="mb-6">
//         <SectionHeader
//           title="Top Customer Concerns"
//           subtitle="Most frequent issues with sentiment analysis"
//           dateFilter={dateFilter}
//           onDateChange={handleDateChange}
//           dateOptions={[
//             'Today',
//             'Yesterday',
//             'Last 7 Days',
//             'Last 14 Days',
//             'Last Month',
//             'Custom Range'
//           ]}
//         />
//       </div>

//       {/* Custom Date Range */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mb-6 animate-in fade-in slide-in-from-top-2">
//           <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 Start Date
//               </label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 End Date
//               </label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <button
//               onClick={handleApplyCustomRange}
//               disabled={!customStartDate || !customEndDate}
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm mt-5 hover:bg-primary/90 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const sentiment = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="bg-background border border-border rounded-lg p-4 transition hover:shadow-md"
//             >
//               {/* Title + Sentiment */}
//               <div className="flex items-start justify-between mb-3">
//                 <div className="flex-1">
//                   <h4 className="text-sm font-semibold text-foreground mb-1">
//                     {concern.category}
//                   </h4>
//                   <p className="text-xs text-muted-foreground line-clamp-2">
//                     {concern.description}
//                   </p>
//                 </div>
//                 <Icon
//                   name={sentiment.name}
//                   size={18}
//                   className={`ml-2 ${sentiment.className}`}
//                 />
//               </div>

//               {/* Metrics */}
//               <div className="space-y-2 mb-3">
//                 <div className="flex items-center justify-between text-xs">
//                   <span className="text-muted-foreground">Volume</span>
//                   <span className="font-medium">
//                     {concern.volume.toLocaleString()} calls
//                   </span>
//                 </div>

//                 <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
//                   <div
//                     className="h-full bg-primary rounded-full transition-all duration-500"
//                     style={{ width: `${concern.percentage}%` }}
//                   />
//                 </div>

//                 {/* ✅ Resolution Rate added */}
//                 <div className="flex items-center justify-between text-xs">
//                   <span className="text-muted-foreground">Resolution Rate</span>
//                   <span className="font-medium text-foreground">
//                     {concern.resolutionRate}%
//                   </span>
//                 </div>
//               </div>

//               {/* Trend */}
//               <div className="flex items-center justify-between pt-3 border-t border-border">
//                 <div className="flex items-center gap-1">
//                   <Icon
//                     name={getTrendIcon(concern.trend)}
//                     size={14}
//                     className={getTrendColor(concern.trend)}
//                   />
//                   <span
//                     className={`text-xs font-medium ${getTrendColor(
//                       concern.trend
//                     )}`}
//                   >
//                     {concern.trend > 0 ? '+' : ''}
//                     {concern.trend}%
//                   </span>
//                 </div>
//                 <span className="text-xs text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;

// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');
//   const [hoveredId, setHoveredId] = useState(null);

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleApplyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;
//     setShowCustomRange(false);
//   };

//   const getSentimentIcon = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return { name: 'ThumbsUp', className: 'text-success' };
//       case 'negative':
//         return { name: 'ThumbsDown', className: 'text-error' };
//       default:
//         return { name: 'Minus', className: 'text-muted-foreground' };
//     }
//   };

//   const getTrendIcon = (trend) => {
//     if (trend > 0) return 'TrendingUp';
//     if (trend < 0) return 'TrendingDown';
//     return 'Minus';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       {/* Header */}
//       <div className="mb-6">
//         <SectionHeader
//           title="Top Customer Concerns"
//           subtitle="Most frequent issues with sentiment analysis"
//           dateFilter={dateFilter}
//           onDateChange={handleDateChange}
//           dateOptions={[
//             'Today',
//             'Yesterday',
//             'Last 7 Days',
//             'Last 14 Days',
//             'Last Month',
//             'Custom Range'
//           ]}
//         />
//       </div>

//       {/* Custom Date Range */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mb-6">
//           <div className="flex flex-col sm:flex-row gap-4 items-end">
//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 Start Date
//               </label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 End Date
//               </label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <button
//               onClick={handleApplyCustomRange}
//               disabled={!customStartDate || !customEndDate}
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm hover:bg-primary/90 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const sentiment = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="relative bg-background border border-border rounded-lg p-4 transition hover:shadow-md"
//               onMouseEnter={() => setHoveredId(concern.id)}
//               onMouseLeave={() => setHoveredId(null)}
//             >
//               {/* 🔥 Tooltip */}
//               {hoveredId === concern.id && (
//                 <div className="absolute z-20 top-2 right-2 w-64 bg-card border border-border rounded-lg shadow-lg p-4 animate-in fade-in zoom-in-95">
//                   <div className="font-semibold text-foreground mb-2 pb-2 border-b border-border">
//                     {concern.category}
//                   </div>

//                   <div className="space-y-2 text-xs">
//                     <div className="flex justify-between">
//                       <span className="text-muted-foreground">Total Calls</span>
//                       <span className="font-medium">
//                         {concern.volume?.toLocaleString()}
//                       </span>
//                     </div>

//                     <div className="flex justify-between">
//                       <span className="text-muted-foreground">
//                         Resolution Rate
//                       </span>
//                       <span className="font-medium text-green-600">
//                         {concern.resolutionRate}%
//                       </span>
//                     </div>

//                     {concern.avgCallDuration && (
//                       <div className="flex justify-between">
//                         <span className="text-muted-foreground">
//                           Avg Duration
//                         </span>
//                         <span className="font-medium">
//                           {concern.avgCallDuration} min
//                         </span>
//                       </div>
//                     )}

//                     {concern.humanEscalation && (
//                       <div className="flex justify-between">
//                         <span className="text-muted-foreground">
//                           Human Escalation
//                         </span>
//                         <span className="font-medium text-orange-600">
//                           {concern.humanEscalation}%
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* Title + Sentiment */}
//               <div className="flex items-start justify-between mb-3">
//                 <div className="flex-1">
//                   <h4 className="text-sm font-semibold text-foreground mb-1">
//                     {concern.category}
//                   </h4>
//                   <p className="text-xs text-muted-foreground line-clamp-2">
//                     {concern.description}
//                   </p>
//                 </div>
//                 <Icon
//                   name={sentiment.name}
//                   size={18}
//                   className={`ml-2 ${sentiment.className}`}
//                 />
//               </div>

//               {/* Metrics */}
//               <div className="space-y-2 mb-3">
//                 <div className="flex items-center justify-between text-xs">
//                   <span className="text-muted-foreground">Volume</span>
//                   <span className="font-medium">
//                     {concern.volume.toLocaleString()} calls
//                   </span>
//                 </div>

//                 <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
//                   <div
//                     className="h-full bg-primary rounded-full transition-all duration-500"
//                     style={{ width: `${concern.percentage}%` }}
//                   />
//                 </div>

//                 <div className="flex items-center justify-between text-xs">
//                   <span className="text-muted-foreground">Resolution Rate</span>
//                   <span className="font-medium">
//                     {concern.resolutionRate}%
//                   </span>
//                 </div>
//               </div>

//               {/* Trend */}
//               <div className="flex items-center justify-between pt-3 border-t border-border">
//                 <div className="flex items-center gap-1">
//                   <Icon
//                     name={getTrendIcon(concern.trend)}
//                     size={14}
//                     className={getTrendColor(concern.trend)}
//                   />
//                   <span
//                     className={`text-xs font-medium ${getTrendColor(
//                       concern.trend
//                     )}`}
//                   >
//                     {concern.trend > 0 ? '+' : ''}
//                     {concern.trend}%
//                   </span>
//                 </div>
//                 <span className="text-xs text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;
















// import React, { useState } from 'react';
// import Icon from '../../../components/AppIcon';
// import SectionHeader from './sectionHeader';

// const ConcernAnalysis = ({ concerns }) => {
//   const [dateFilter, setDateFilter] = useState('Last 7 Days');
//   const [showCustomRange, setShowCustomRange] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState('');
//   const [customEndDate, setCustomEndDate] = useState('');
//   const [hoveredId, setHoveredId] = useState(null);

//   const handleDateChange = (value) => {
//     setDateFilter(value);
//     setShowCustomRange(value === 'Custom Range');
//   };

//   const handleApplyCustomRange = () => {
//     if (!customStartDate || !customEndDate) return;
//     setShowCustomRange(false);
//   };

//   const getSentimentIcon = (sentiment) => {
//     switch (sentiment) {
//       case 'positive':
//         return { name: 'ThumbsUp', className: 'text-success' };
//       case 'negative':
//         return { name: 'ThumbsDown', className: 'text-error' };
//       default:
//         return { name: 'Minus', className: 'text-muted-foreground' };
//     }
//   };

//   const getTrendIcon = (trend) => {
//     if (trend > 0) return 'TrendingUp';
//     if (trend < 0) return 'TrendingDown';
//     return 'Minus';
//   };

//   const getTrendColor = (trend) => {
//     if (trend > 0) return 'text-error';
//     if (trend < 0) return 'text-success';
//     return 'text-muted-foreground';
//   };

//   return (
//     <div className="bg-card border border-border rounded-lg p-4 md:p-6">
//       {/* Header */}
//       <div className="mb-6">
//         <SectionHeader
//           title="Top Customer Concerns"
//           subtitle="Most frequent issues with sentiment analysis"
//           dateFilter={dateFilter}
//           onDateChange={handleDateChange}
//           dateOptions={[
//             'Today',
//             'Yesterday',
//             'Last 7 Days',
//             'Last 14 Days',
//             'Last Month',
//             'Custom Range'
//           ]}
//         />
//       </div>

//       {/* Custom Date Range */}
//       {showCustomRange && (
//         <div className="bg-background border border-border rounded-lg p-4 mb-6">
//           <div className="flex flex-col sm:flex-row gap-4 items-end">
//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 Start Date
//               </label>
//               <input
//                 type="date"
//                 value={customStartDate}
//                 onChange={(e) => setCustomStartDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="text-xs text-muted-foreground mb-1 block">
//                 End Date
//               </label>
//               <input
//                 type="date"
//                 value={customEndDate}
//                 onChange={(e) => setCustomEndDate(e.target.value)}
//                 className="w-full border border-border rounded-lg px-3 py-2 text-sm"
//               />
//             </div>

//             <button
//               onClick={handleApplyCustomRange}
//               disabled={!customStartDate || !customEndDate}
//               className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm hover:bg-primary/90 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//         {concerns?.map((concern) => {
//           const sentiment = getSentimentIcon(concern.sentiment);

//           return (
//             <div
//               key={concern.id}
//               className="relative bg-background border border-border rounded-lg p-4 transition hover:shadow-md"
//               onMouseEnter={() => setHoveredId(concern.id)}
//               onMouseLeave={() => setHoveredId(null)}
//             >
//               {/* 🔥 Tooltip */}
//               {hoveredId === concern.id && (
//                 <div className="absolute z-20 top-2 right-2 w-64 bg-card border border-border rounded-lg shadow-lg p-4 animate-in fade-in zoom-in-95">
//                   <div className="font-semibold text-foreground mb-2 pb-2 border-b border-border">
//                     {concern.category}
//                   </div>

//                   <div className="space-y-2 text-xs">
//                     <div className="flex justify-between">
//                       <span className="text-muted-foreground">Total Calls</span>
//                       <span className="font-medium">
//                         {concern.volume?.toLocaleString()}
//                       </span>
//                     </div>

//                     {concern.avgCallDuration && (
//                       <div className="flex justify-between">
//                         <span className="text-muted-foreground">Avg Duration</span>
//                         <span className="font-medium">{concern.avgCallDuration} min</span>
//                       </div>
//                     )}

//                     {concern.volume && concern.avgCallDuration && (
//                       <div className="flex justify-between">
//                         <span className="text-muted-foreground">Total Minutes</span>
//                         <span className="font-medium">
//                           {concern.volume * concern.avgCallDuration} min
//                         </span>
//                       </div>
//                     )}

//                     {concern.resolutionRate !== undefined && (
//                       <div className="flex justify-between">
//                         <span className="text-muted-foreground">Autonomous call Completion Rate</span>
//                         <span className="font-medium text-green-600">
//                           {concern.resolutionRate}%
//                         </span>
//                       </div>
//                     )}

//                     {concern.humanEscalation !== undefined && (
//                       <div className="flex justify-between">
//                         <span className="text-muted-foreground">Human Escalation</span>
//                         <span className="font-medium text-orange-600">
//                           {concern.humanEscalation}%
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* Title + Sentiment */}
//               <div className="flex items-start justify-between mb-3">
//                 <div className="flex-1">
//                   <h4 className="text-sm font-semibold text-foreground mb-1">
//                     {concern.category}
//                   </h4>
//                   {/* <p className="text-xs text-muted-foreground line-clamp-2">
//                     {concern.description}
//                   </p> */}
//                 </div>
//                 <Icon
//                   name={sentiment.name}
//                   size={18}
//                   className={`ml-2 ${sentiment.className}`}
//                 />
//               </div>

//               {/* Metrics */}
//               <div className="space-y-2 mb-3">
//                 <div className="flex items-center justify-between text-xs">
//                   <span className="text-muted-foreground">Volume</span>
//                   <span className="font-medium">
//                     {concern.volume.toLocaleString()} calls
//                   </span>
//                 </div>

//                 <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
//                   <div
//                     className="h-full bg-primary rounded-full transition-all duration-500"
//                     style={{ width: `${concern.percentage}%` }}
//                   />
//                 </div>

//                 <div className="flex items-center justify-between text-xs">
//                   <span className="text-muted-foreground">Autonomous call Completion Rate</span>
//                   <span className="font-medium">{concern.resolutionRate}%</span>
//                 </div>
//               </div>

//               {/* Trend */}
//               <div className="flex items-center justify-between pt-3 border-t border-border">
//                 <div className="flex items-center gap-1">
//                   <Icon
//                     name={getTrendIcon(concern.trend)}
//                     size={14}
//                     className={getTrendColor(concern.trend)}
//                   />
//                   <span
//                     className={`text-xs font-medium ${getTrendColor(
//                       concern.trend
//                     )}`}
//                   >
//                     {concern.trend > 0 ? '+' : ''}
//                     {concern.trend}%
//                   </span>
//                 </div>
//                 <span className="text-xs text-muted-foreground">
//                   vs last period
//                 </span>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ConcernAnalysis;






























import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import SectionHeader from './SectionHeader';
import api from '../../../api/axios'; // ← use your axios instance

const ConcernAnalysis = () => {
  const [dateFilter, setDateFilter] = useState('Last 7 Days');
  const [showCustomRange, setShowCustomRange] = useState(false);
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [hoveredId, setHoveredId] = useState(null);
  const [concerns, setConcerns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Calculate date range
  const getDateRange = (filter) => {
    const now = new Date();
    const end = new Date(now);
    end.setHours(23, 59, 59, 999);
    let start = new Date(now);

    switch (filter) {
      case 'Today':
        start.setHours(0, 0, 0, 0);
        break;
      case 'Yesterday':
        start.setDate(start.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
        break;
      case 'Last 7 Days':
        start.setDate(start.getDate() - 7);
        start.setHours(0, 0, 0, 0);
        break;
      case 'Last 14 Days':
        start.setDate(start.getDate() - 14);
        start.setHours(0, 0, 0, 0);
        break;
      case 'Last Month':
        start.setDate(start.getDate() - 30);
        start.setHours(0, 0, 0, 0);
        break;
      default:
        return null;
    }

    return { start, end };
  };

  const formatDateForAPI = (date) => date.toISOString().slice(0, 19);

  const fetchConcerns = async (startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const from = formatDateForAPI(startDate);
      const to = formatDateForAPI(endDate);

      const res = await api.get('/api/v1/dashboard/customer-concerns', {
        params: { from, to },
      });

      const data = res.data?.data;
      if (!data?.concernMetricsList) {
        setConcerns([]);
        return;
      }

      const totalCalls = data.totalCallsInPeriod || 0;

      const transformed = data.concernMetricsList.map((item, index) => {
        const percentage = totalCalls > 0 ? (item.totalCalls / totalCalls) * 100 : 0;

        return {
          id: index + 1,
          category: item.concern || 'Unknown',
          volume: item.totalCalls || 0,
          percentage: Math.min(percentage, 100),
          resolutionRate: (item.aiResolutionRate || 0).toFixed(1),
          sentiment: (item.sentiment || 'neutral').toLowerCase(),
          trend: item.trend || 0,
          avgCallDuration: ((item.avgCallDuration || 0) / 60).toFixed(1),
          humanEscalation: (item.humanEscalationPercent || 0).toFixed(1),
          totalMinutes: (item.totalMinutes || 0).toFixed(1),
        };
      });

      setConcerns(transformed);
    } catch (err) {
      console.error('Error fetching concerns:', err);
      setError(err.response?.data?.message || err.message || 'Failed to fetch concerns');
      setConcerns([]);
    } finally {
      setLoading(false);
    }
  };

  // Load on date filter change
  useEffect(() => {
    if (dateFilter !== 'Custom Range') {
      const range = getDateRange(dateFilter);
      if (range) fetchConcerns(range.start, range.end);
    }
  }, [dateFilter]);

  const handleDateChange = (value) => {
    setDateFilter(value);
    setShowCustomRange(value === 'Custom Range');
  };

  const handleApplyCustomRange = () => {
    if (!customStartDate || !customEndDate) return;

    const start = new Date(customStartDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(customEndDate);
    end.setHours(23, 59, 59, 999);

    if (start > end) {
      setError('Start date must be before end date');
      return;
    }

    fetchConcerns(start, end);
    setShowCustomRange(false);
  };

  const getSentimentIcon = (sentiment) => {
    switch (sentiment) {
      case 'positive':
        return { name: 'ThumbsUp', className: 'text-success' };
      case 'negative':
        return { name: 'ThumbsDown', className: 'text-error' };
      default:
        return { name: 'Minus', className: 'text-muted-foreground' };
    }
  };

  const getTrendIcon = (trend) => (trend > 0 ? 'TrendingUp' : trend < 0 ? 'TrendingDown' : 'Minus');
  const getTrendColor = (trend) => (trend > 0 ? 'text-error' : trend < 0 ? 'text-success' : 'text-muted-foreground');


  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      {/* Header */}
      <div className="mb-6">
        <SectionHeader
          title="Top Customer Concerns"
          subtitle="Most frequent issues with sentiment analysis"
          dateFilter={dateFilter}
          onDateChange={handleDateChange}
          dateOptions={[
            'Today',
            'Yesterday',
            'Last 7 Days',
            'Last 14 Days',
            'Last Month',
            'Custom Range'
          ]}
        />
      </div>

      {/* Custom Date Range */}
      {showCustomRange && (
        <div className="bg-background border border-border rounded-lg p-4 mb-6">
          <div className="flex flex-col sm:flex-row gap-4 items-end">
            <div className="flex-1">
              <label className="text-xs text-muted-foreground mb-1 block">
                Start Date
              </label>
              <input
                type="date"
                value={customStartDate}
                onChange={(e) => setCustomStartDate(e.target.value)}
                className="w-full border border-border rounded-lg px-3 py-2 text-sm"
              />
            </div>

            <div className="flex-1">
              <label className="text-xs text-muted-foreground mb-1 block">
                End Date
              </label>
              <input
                type="date"
                value={customEndDate}
                onChange={(e) => setCustomEndDate(e.target.value)}
                className="w-full border border-border rounded-lg px-3 py-2 text-sm"
              />
            </div>

            <button
              onClick={handleApplyCustomRange}
              disabled={!customStartDate || !customEndDate}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm hover:bg-primary/90 disabled:opacity-50"
            >
              Apply
            </button>
          </div>
        </div>
      )}

      {/* Error Message */}
      {error && (
        <div className="bg-error/10 border border-error/20 text-error rounded-lg p-3 mb-4 text-sm">
          {error}
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      )}

      {/* Empty State */}
      {!loading && concerns.length === 0 && !error && (
        <div className="text-center py-12 text-muted-foreground">
          <Icon name="MessageSquare" size={48} className="mx-auto mb-3 opacity-50" />
          <p>No concerns found for the selected period</p>
        </div>
      )}

      {/* Cards */}
      {!loading && concerns.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {concerns.map((concern) => {
            const sentiment = getSentimentIcon(concern.sentiment);

            return (
              <div
                key={concern.id}
                className="relative bg-background border border-border rounded-lg p-4 transition hover:shadow-md"
                onMouseEnter={() => setHoveredId(concern.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Tooltip */}
                {hoveredId === concern.id && (
                  <div className="absolute z-20 top-2 right-2 w-64 bg-card border border-border rounded-lg shadow-lg p-4 animate-in fade-in zoom-in-95">
                    <div className="font-semibold text-foreground mb-2 pb-2 border-b border-border">
                      {concern.category}
                    </div>

                    <div className="space-y-2 text-xs">
                      <div className="flex justify-between">
                        <span className="text-muted-foreground">Total Calls</span>
                        <span className="font-medium">
                          {concern.volume?.toLocaleString()}
                        </span>
                      </div>

                      {concern.avgCallDuration && (
                        <div className="flex justify-between">
                          <span className="text-muted-foreground">Avg Duration</span>
                          <span className="font-medium">{concern.avgCallDuration} min</span>
                        </div>
                      )}

                      {concern.totalMinutes && (
                        <div className="flex justify-between">
                          <span className="text-muted-foreground">Total Minutes</span>
                          <span className="font-medium">
                            {concern.totalMinutes} min
                          </span>
                        </div>
                      )}

                      {concern.resolutionRate !== undefined && (
                        <div className="flex justify-between">
                          <span className="text-muted-foreground">Auto Resolved</span>
                          <span className="font-medium text-green-600">
                            {concern.resolutionRate}%
                          </span>
                        </div>
                      )}

                      {concern.humanEscalation !== undefined && (
                        <div className="flex justify-between">
                          <span className="text-muted-foreground">Human Escalation</span>
                          <span className="font-medium text-orange-600">
                            {concern.humanEscalation}%
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Title + Sentiment */}
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <h4 className="text-sm font-semibold text-foreground mb-1">
                      {concern.category}
                    </h4>
                  </div>
                  <Icon
                    name={sentiment.name}
                    size={18}
                    className={`ml-2 ${sentiment.className}`}
                  />
                </div>

                {/* Metrics */}
                <div className="space-y-2 mb-3">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-muted-foreground">Volume</span>
                    <span className="font-medium">
                      {concern.volume.toLocaleString()} calls
                    </span>
                  </div>

                  <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                    <div
                      className="h-full bg-primary rounded-full transition-all duration-500"
                      style={{ width: `${concern.percentage}%` }}
                    />
                  </div>

                  <div className="flex items-center justify-between text-xs">
                    <span className="text-muted-foreground">Autonomous call Completion Rate</span>
                    <span className="font-medium">{concern.resolutionRate}%</span>
                  </div>
                </div>

                {/* Trend */}
                <div className="flex items-center justify-between pt-3 border-t border-border">
                  <div className="flex items-center gap-1">
                    <Icon
                      name={getTrendIcon(concern.trend)}
                      size={14}
                      className={getTrendColor(concern.trend)}
                    />
                    <span
                      className={`text-xs font-medium ${getTrendColor(
                        concern.trend
                      )}`}
                    >
                      {concern.trend > 0 ? '+' : ''}
                      {concern.trend}%
                    </span>
                  </div>
                  <span className="text-xs text-muted-foreground">
                    vs last period
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ConcernAnalysis;